
export const name = "settings-ui-security";
export const version = "dev";
